import React from "react";

const WhyInvestEtf2 = ({ ...rest }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="49"
            height="49"
            viewBox="0 0 49 49"
            fill="none"
            {...rest}
        >
            <rect opacity="0.2" x="4.25" y="5" width="44" height="44" fill="#E1AAAA" />
            <rect x="1" y="1" width="44" height="44" stroke="#D38D8D" strokeWidth="2" />
            <path
                d="M23.0002 26.2083H18.8752C17.5959 26.2083 16.9563 26.2083 16.4358 26.3662C15.2639 26.7217 14.3469 27.6388 13.9914 28.8106C13.8335 29.3311 13.8335 29.9707 13.8335 31.25M26.6668 28.5L28.5002 30.3333L32.1668 26.6667M25.2918 18.875C25.2918 21.1532 23.445 23 21.1668 23C18.8887 23 17.0418 21.1532 17.0418 18.875C17.0418 16.5968 18.8887 14.75 21.1668 14.75C23.445 14.75 25.2918 16.5968 25.2918 18.875Z"
                stroke="#E1AAAA"
                strokeWidth="1.83563"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default WhyInvestEtf2;
